import React from 'react';
import { StarIcon, QuoteIcon } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    name: 'Maria González',
    location: 'Miami, FL',
    image: 'https://randomuser.me/api/portraits/women/44.jpg',
    text: 'Estaba desesperada. Tenía un score de 540 y nadie me daba un préstamo para mi negocio de catering. Con este código, borré 3 colecciones médicas y mi score subió a 720 en 3 meses. ¡Ya tengo mi van nueva!',
    score: 'Subió +180 puntos'
  }, {
    name: 'Sofia Ramirez',
    location: 'Houston, TX',
    image: 'https://randomuser.me/api/portraits/women/68.jpg',
    text: 'Lo que más me gustó fue que no tuve que pagarle a nadie mes a mes. Las cartas ya están hechas, solo puse mis datos y las envié. Los burós no tuvieron opción más que borrar la información incorrecta.',
    score: 'Subió +115 puntos'
  }, {
    name: 'Elena Torres',
    location: 'Los Angeles, CA',
    image: 'https://randomuser.me/api/portraits/women/33.jpg',
    text: 'Pensé que esto era muy complicado para mí, pero la guía te lleva de la mano. Pude comprar mi primera casa con un interés del 5% en lugar del 9% que me ofrecían antes. ¡Gracias!',
    score: 'Aprobada para Hipoteca'
  }];
  return <section className="py-12 md:py-20 bg-cream" data-id="element-183">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-184">
        <div className="text-center mb-10 md:mb-16" data-id="element-185">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-navy mb-3" data-id="element-186">
            Latinas reales, resultados reales
          </h2>
          <div className="flex justify-center gap-1 text-gold" data-id="element-187">
            {[1, 2, 3, 4, 5].map(i => <StarIcon key={i} className="w-5 h-5 fill-current" data-id="element-188" />)}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8" data-id="element-189">
          {testimonials.map((t, index) => <div key={index} className="bg-white px-6 pb-6 pt-14 rounded-2xl shadow-sm relative" data-id="element-190">
              <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2" data-id="element-191">
                <img src={t.image} alt={t.name} className="w-16 h-16 rounded-full border-4 border-white shadow-md object-cover" data-id="element-192" />
              </div>
              <div className="absolute top-6 left-6 opacity-10" data-id="element-193">
                <QuoteIcon className="w-8 h-8 text-navy" data-id="element-194" />
              </div>

              <div className="text-center" data-id="element-195">
                <p className="text-gray-600 italic mb-4 text-sm relative z-10" data-id="element-196">
                  "{t.text}"
                </p>
                <h4 className="font-heading font-bold text-navy text-base" data-id="element-197">
                  {t.name}
                </h4>
                <p className="text-gray-400 text-xs mb-3" data-id="element-198">{t.location}</p>
                <div className="inline-block bg-green-100 text-green-800 text-xs font-bold px-3 py-1 rounded-full" data-id="element-199">
                  {t.score}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}